import client from './client';

export interface ScenarioRecord {
  id: number;
  source_reported_message_id: number;
  name: string;
  skill_tag: string;
  kind: 'threat' | 'benign';
  version: number;
  subject: string;
  html: string;
  text: string;
  status: string;
  reviewed_by: string;
  reviewed_at: string;
  created_at: string;
}

export type ScenarioOption = Pick<ScenarioRecord, 'id' | 'name' | 'skill_tag' | 'kind' | 'status'>;

export const scenariosApi = {
  getAll: () => client.get<ScenarioRecord[]>('/scenarios/'),
  getById: (id: number) => client.get<ScenarioRecord>(`/scenarios/${id}`),
  approve: (id: number) => client.post<ScenarioRecord>(`/scenarios/${id}/approve`, {}),
};
